/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectImageReference } from '../../models/project-image-reference';

export interface GetProjectImageReferences$Params {
  projectId: string;
}

export function getProjectImageReferences(http: HttpClient, rootUrl: string, params: GetProjectImageReferences$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProjectImageReference>>> {
  const rb = new RequestBuilder(rootUrl, getProjectImageReferences.PATH, 'get');
  if (params) {
    rb.path('projectId', params.projectId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProjectImageReference>>;
    })
  );
}

getProjectImageReferences.PATH = '/project/{projectId}/images';
